const cardData = [
  {
    id: "indianMinds",
    linkType: "internal",
    linkURL: "/indian-minds",
    buttonText: "Indian Minds",
  },
 
  {
    id: "scienceApp",
    linkType: "internal",
    linkURL: "/Mathemartica",
    buttonText: "Mathemartica",
  },
 
  {
    id: "fos",
    linkType: "internal",
    linkURL: "/fields-of-science",
    buttonText: "Fields of Science",
  },
  {
    id: "equGallery",
    linkType: "internal",
    linkURL: "/equational-gallery",
    buttonText: "Equational Gallery",
  },
  
  {
    id: "evolutionSci",
    linkType: "internal",
    linkURL: "/timeline-of-reality",
    buttonText: "Timeline of Reality",
  },
  {
    id: "funSci",
    linkType: "internal",
    linkURL: "/fun-with-science",
    buttonText: "Fun Science Online",
  },
 
  
  // {
  //   id: "frequency_test",
  //   linkType: "external",
  //   linkURL: "https://master.d2nlbvj7shrjov.amplifyapp.com/",
  //   buttonText: "Hearing Age Test",
  // },
  // {
  //   id: "frequency_sound",
  //   linkType: "external",
  //   linkURL: "https://main.dpo979ruosk1k.amplifyapp.com/",
  //   buttonText: "Audio Analyser",
  // }

];


export default cardData;